/**
 * BE BOLD : Path B: Release and Rebuild
 * Month 2: Release + Gentle Push (Days 31-60)
 *
 * RELAX leads. Gentle Push introduced at 10-20% effort.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  butterfly_breath: {
    id: 'butterfly_breath',
    pose: 'butterfly',
    name: 'Butterfly Breath',
    name_pt: 'Respiração Borboleta',
    sub: 'Knees open like wings. Floor opens with them.',
    sub_pt: 'Joelhos abrem como asas. Assoalho abre com eles.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Lie on your back. Bring the soles of your feet together and let your knees fall open to the sides. If this pulls on your inner thighs, place pillows under each knee.

Inhale for 4 counts. Feel the gentle stretch across the inner thighs and perineum. Your pelvic floor widens naturally in this position.

Exhale for 6 counts. Let everything soften further. On each exhale, let the knees drop 1mm more.

Stay here and breathe. The position does the work.

Picture it: a butterfly resting with wings open on a warm rock. The wings do not flap. They just rest. Your knees are the wings.`,
    inst_pt: `Deite de costas. Junte as solas dos pés e deixe os joelhos caírem para os lados. Se puxar as coxas internas, coloque travesseiros sob cada joelho.

Inspire por 4 tempos. Sinta o alongamento suave nas coxas internas e períneo. Seu assoalho pélvico se alarga naturalmente nessa posição.

Expire por 6 tempos. Deixe tudo amolecer mais. Em cada expiração, deixe os joelhos caírem 1mm mais.

Fique aqui e respire. A posição faz o trabalho.

Visualize: borboleta descansando com asas abertas numa pedra quente. As asas não batem. Apenas descansam. Seus joelhos são as asas.`,
    breathe: 'Inhale to feel the stretch. Exhale to soften into it.',
    breathe_pt: 'Inspire para sentir o alongamento. Expire para amolecer nele.',
    timerCue: `Inhale.
Feel.
Exhale.
Soften.`,
    timerCue_pt: `Inspire.
Sinta.
Expire.
Amoleça.`,
    feel: 'A gentle opening across the inner thighs and perineum. The floor widening without effort.',
    feel_pt: 'Uma abertura suave nas coxas internas e períneo. O assoalho alargando sem esforço.',
    avoid: 'Do not force your knees down. Do not bear down. If hip pain, raise pillows higher.',
    avoid_pt: 'Não force os joelhos. Não faça força. Se dor no quadril, levante travesseiros mais.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  counting_breath: {
    id: 'counting_breath',
    name: 'Counting Breath',
    name_pt: 'Respiração com Contagem',
    sub: 'Count the exhale longer. The floor follows the count.',
    sub_pt: 'Conte a expiração mais longa. O assoalho segue a contagem.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat. Close your eyes.

Round 1 (5 breaths): Inhale 3 counts. Exhale 5 counts. Short and calm.

Round 2 (5 breaths): Inhale 4 counts. Exhale 6 counts. A bit longer.

Round 3 (5 breaths): Inhale 4 counts. Exhale 8 counts. The longest exhale teaches your nervous system to shift into rest mode. Your pelvic floor softens more with each longer exhale.

If 8 counts is too long, stay at 6. The exhale is always longer than the inhale. That is what tells the body it is safe.

Picture it: slowly letting air out of a balloon. The longer the hiss, the flatter the balloon becomes. Your pelvic floor is the balloon. Or a train slowing into a station. Each longer exhale is a longer brake. By Round 3, the train has stopped completely.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados. Feche os olhos.

Rodada 1 (5 respirações): Inspire 3 tempos. Expire 5 tempos. Curta e calma.

Rodada 2 (5 respirações): Inspire 4 tempos. Expire 6 tempos. Um pouco mais longa.

Rodada 3 (5 respirações): Inspire 4 tempos. Expire 8 tempos. A expiração mais longa ensina seu sistema nervoso a entrar em modo de descanso. Seu assoalho pélvico amolece mais a cada expiração mais longa.

Se 8 tempos for muito, fique em 6. A expiração é sempre mais longa que a inspiração. É isso que diz ao corpo que está seguro.

Visualize: soltando ar lentamente de um balão. Quanto mais longo o chiado, mais murcho fica. Seu assoalho pélvico é o balão. Ou um trem parando numa estação. Cada expiração mais longa é um freio mais longo. Na Rodada 3, o trem parou completamente.`,
    breathe: 'Round 1: in 3, out 5. Round 2: in 4, out 6. Round 3: in 4, out 8.',
    breathe_pt: 'Rodada 1: inspira 3, expira 5. Rodada 2: inspira 4, expira 6. Rodada 3: inspira 4, expira 8.',
    timerCue: `Inhale.
Count.
Exhale.
Longer.`,
    timerCue_pt: `Inspire.
Conte.
Expire.
Mais longo.`,
    feel: 'Each round gets calmer. The longer exhale shifts your whole body into rest mode.',
    feel_pt: 'Cada rodada fica mais calma. A expiração mais longa muda o corpo inteiro para modo de descanso.',
    avoid: 'Do not force longer counts. If dizzy, return to normal breathing. Do not bear down.',
    avoid_pt: 'Não force contagens mais longas. Se sentir tontura, volte à respiração normal. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 7,
    rest: 0,
  },

  gentle_candle_blow: {
    id: 'gentle_candle_blow',
    name: 'Gentle Candle Blow',
    name_pt: 'Sopro de Vela Suave',
    sub: 'The smallest downward intention. 10-15% effort.',
    sub_pt: 'A menor intenção para baixo. 10-15% de esforço.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `Lie on your back, knees bent. Complete 3 belly breaths to prepare.

On your next exhale, add a tiny downward intention. 10% effort. Like gently blowing out a birthday candle, but from below. Not straining. A whisper of movement.

Hold the gentle open feeling for 4 seconds. Then release the effort but stay soft. Breathe normally for 6 seconds.

If 10% feels like too much, try 5%. The effort should be invisible to anyone watching.

Picture it: gently pushing a swing door with your fingertips. It swings open on its own hinges. Or blowing a soap bubble, the effort is tiny, the opening is soft and round.`,
    inst_pt: `Deite de costas, joelhos dobrados. Complete 3 respirações abdominais para preparar.

Na próxima expiração, adicione uma intenção mínima para baixo. 10% de esforço. Como soprar uma vela de aniversário suavemente, mas de baixo. Sem forçar. Um sussurro de movimento.

Mantenha a sensação de abertura suave por 4 segundos. Depois solte o esforço mas continue macia. Respire normalmente por 6 segundos.

Se 10% parecer demais, tente 5%. O esforço deve ser invisível para quem observa.

Visualize: empurrando uma porta vai-e-vem com as pontas dos dedos. Ela abre sozinha. Ou soprando uma bolha de sabão, o esforço é mínimo, a abertura é macia e redonda.`,
    breathe: 'Exhale to push gently down. Inhale to rest.',
    breathe_pt: 'Expire para empurrar suave. Inspire para descansar.',
    timerCue: `Exhale.
Push gently.
Hold.
Release.`,
    timerCue_pt: `Expire.
Empurre suave.
Segure.
Solte.`,
    feel: 'A tiny widening or opening sensation, almost imperceptible. A faint softening that is easy to miss.',
    feel_pt: 'Uma sensação mínima de abertura, quase imperceptível. Um amolecimento sutil, fácil de não perceber.',
    avoid: 'Do not strain. Do not bear down hard. If you feel bulging or pressure, reduce to 5%.',
    avoid_pt: 'Não force. Se sentir protuberância ou pressão, reduza para 5%.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  hip_rock_release: {
    id: 'hip_rock_release',
    name: 'Hip Rock Release',
    name_pt: 'Balanço do Quadril',
    sub: 'Movement teaches the floor to let go.',
    sub_pt: 'Movimento ensina o assoalho a soltar.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat.

Slowly tilt your pelvis forward: your low back arches slightly away from the floor. Feel your pelvic floor gently stretch open.

Slowly tilt your pelvis back: your low back presses into the floor. Feel your pelvic floor gently compress.

Rock between these two positions slowly. Forward tilt opens the floor. Back tilt closes it lightly. Each rock takes about 4 seconds forward, 4 seconds back.

During the forward tilt, actively breathe into the stretch. Let the floor open.

Picture it: your pelvis is a bowl of water. Tilt forward, water tips toward your belly button. Tilt back, water tips toward your spine. Smooth, no spilling. Or a rocking chair in slow motion, the whole thing moving as one piece.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Lentamente incline a pelve para frente: a lombar se afasta levemente do chão. Sinta o assoalho pélvico se alongar suavemente.

Lentamente incline a pelve para trás: a lombar pressiona o chão. Sinta o assoalho pélvico comprimir levemente.

Balance entre as duas posições devagar. Inclinação frontal abre o assoalho. Inclinação posterior fecha levemente. Cada balanço leva cerca de 4 segundos para frente, 4 para trás.

Durante a inclinação frontal, respire ativamente no alongamento. Deixe o assoalho abrir.

Visualize: sua pelve é uma tigela de água. Incline para frente, água vai ao umbigo. Incline para trás, água vai à coluna. Suave, sem derramar. Ou cadeira de balanço em câmera lenta, tudo se movendo como uma peça.`,
    breathe: 'Inhale as you tilt forward (open). Exhale as you tilt back (neutral).',
    breathe_pt: 'Inspire ao inclinar para frente (abrir). Expire ao inclinar para trás (neutro).',
    timerCue: `Forward.
Open.
Back.
Neutral.`,
    timerCue_pt: `Frente.
Abra.
Trás.
Neutro.`,
    feel: 'A gentle rocking that alternates between stretching and softening. Like a wave inside your pelvis.',
    feel_pt: 'Um balanço suave que alterna entre alongar e amolecer. Como uma onda dentro da pelve.',
    avoid: 'Do not rush. Do not lift your hips off the ground. Do not bear down.',
    avoid_pt: 'Não apresse. Não levante o quadril do chão. Não faça força.',
    type: 'alt',
    sets: 19,
    hold: 4,
    relax: 4,
    rest: 0,
    altA: 'Forward',
    altA_pt: 'Frente',
    altB: 'Back',
    altB_pt: 'Trás',
  },

  pelvic_floor_drop: {
    id: 'pelvic_floor_drop',
    pose: 'pf-drop',
    name: 'Pelvic Floor Drop',
    name_pt: 'Queda do Assoalho',
    sub: 'Gravity does the work. You just breathe.',
    sub_pt: 'A gravidade faz o trabalho. Você só respira.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back. Pull both knees gently toward your chest. Let them fall apart. Hold behind each knee with your hands.

Breathe in for 4 counts. Feel your pelvic floor widen between your sit bones.

Breathe out for 6 counts. Let everything drop. Nothing holds.

On each exhale, imagine the space between your sit bones getting 1mm wider. Stay in this position for the full time.

Picture it: two small islands drifting apart on a calm ocean. Each breath pushes them gently further.`,
    inst_pt: `Deite de costas. Puxe os joelhos suavemente em direção ao peito. Deixe-os cair para os lados. Segure atrás de cada joelho com as mãos.

Inspire por 4 tempos. Sinta seu assoalho pélvico alargar entre os ísquios.

Expire por 6 tempos. Deixe tudo cair. Nada segura.

Em cada expiração, imagine o espaço entre seus ísquios ficando 1mm mais largo. Fique aqui pelo tempo todo.

Visualize: duas pequenas ilhas se afastando num oceano calmo. Cada respiração as empurra suavemente.`,
    breathe: 'Inhale to widen. Exhale to drop deeper.',
    breathe_pt: 'Inspire para alargar. Expire para soltar mais fundo.',
    timerCue: `Inhale.
Widen.
Exhale.
Drop.`,
    timerCue_pt: `Inspire.
Alargue.
Expire.
Solte.`,
    feel: 'A gentle opening between the sit bones on every breath. Gravity pulling the floor downward. No effort.',
    feel_pt: 'Uma abertura suave entre os ísquios a cada respiração. Gravidade puxando o assoalho para baixo. Sem esforço.',
    avoid: 'Do not push or bear down. Do not squeeze your knees together. Do not tense your inner thighs.',
    avoid_pt: 'Não empurre nem faça força. Não aperte os joelhos juntos. Não tensione as coxas internas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  push_and_return: {
    id: 'push_and_return',
    name: 'Push and Return',
    name_pt: 'Empurre e Volte',
    sub: 'Down 20%. Back to neutral. Learning two directions.',
    sub_pt: 'Desça 20%. Volte ao neutro. Aprendendo duas direções.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `Sit on a firm chair, feet flat.

Exhale and gently push the pelvic floor downward. 20% effort. Hold for 4 seconds.

Inhale and let the floor return to neutral. Not squeezing up. Just neutral. Like a trampoline bouncing back to resting position after a gentle press.

The return is NOT a squeeze. It is a passive bounce back.

Picture it: pressing a piano key down gently, then letting your finger lift. The key returns on its own spring. Or pressing a sponge underwater and letting it expand back.`,
    inst_pt: `Sente numa cadeira firme, pés apoiados.

Expire e empurre suavemente o assoalho para baixo. 20% esforço. Segure por 4 segundos.

Inspire e deixe o assoalho voltar ao neutro. Não apertando para cima. Apenas neutro. Como um trampolim voltando após pressão suave.

O retorno NÃO é um aperto. É um retorno passivo.

Visualize: pressionando tecla de piano suavemente, depois deixando voltar. A tecla volta pela mola. Ou pressionando esponja na água e deixando expandir.`,
    breathe: 'Exhale to push. Inhale to return.',
    breathe_pt: 'Expire para empurrar. Inspire para voltar.',
    timerCue: `Exhale.
Push.
Inhale.
Return.`,
    timerCue_pt: `Expire.
Empurre.
Inspire.
Volte.`,
    feel: 'A gentle downward movement followed by a natural return.',
    feel_pt: 'Um movimento suave para baixo seguido de retorno natural.',
    avoid: 'Do not squeeze on the return. Do not bear down hard.',
    avoid_pt: 'Não aperte no retorno. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  side_lying_release: {
    id: 'side_lying_release',
    pose: 'side-lying',
    name: 'Side Lying Release',
    name_pt: 'Soltura de Lado',
    sub: 'The gentlest position. Zero gravity load on the floor.',
    sub_pt: 'A posição mais suave. Zero carga de gravidade no assoalho.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your side with a pillow between your knees. Your spine should be neutral. Place one hand on your lower belly.

Inhale for 4 counts. Feel your belly push forward against your hand. Your pelvic floor releases toward the back.

Exhale for 6 counts. Stay soft everywhere. Nothing activates.

This position removes gravity from the equation. Your floor is completely unloaded. It can release fully without fighting anything.

Picture it: a cat sleeping curled on its side. Every breath makes it softer. Every exhale melts it deeper into the cushion. Be the cat. Or snow melting on a warm windowsill, slowly and silently becoming water.`,
    inst_pt: `Deite de lado com um travesseiro entre os joelhos. Sua coluna deve estar neutra. Coloque uma mão na barriga baixa.

Inspire por 4 tempos. Sinta a barriga empurrar para frente contra sua mão. Seu assoalho pélvico solta em direção às costas.

Expire por 6 tempos. Fique macia em todo lugar. Nada ativa.

Essa posição remove a gravidade da equação. Seu assoalho está completamente descarregado. Pode soltar totalmente sem lutar contra nada.

Visualize: um gato dormindo de lado. Cada respiração o deixa mais macio. Cada expiração derrete na almofada. Seja o gato. Ou neve derretendo num parapeito quente, lenta e silenciosamente virando água.`,
    breathe: 'Inhale to expand. Exhale to stay released.',
    breathe_pt: 'Inspire para expandir. Expire para continuar solta.',
    timerCue: `Inhale.
Expand.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Expanda.
Expire.
Fique macia.`,
    feel: 'Very little, by design. The point is the absence of tension.',
    feel_pt: 'Quase nada, de propósito. O ponto é a ausência de tensão.',
    avoid: 'Do not bear down. Do not try to feel anything dramatic.',
    avoid_pt: 'Não faça força. Não tente sentir nada dramático.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  warm_hands_release: {
    id: 'warm_hands_release',
    name: 'Warm Hands Release',
    name_pt: 'Soltura com Mãos Quentes',
    sub: 'Warmth tells your body it is safe to soften.',
    sub_pt: 'Calor diz ao corpo que é seguro amolecer.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Rub your palms together vigorously for 10 seconds until they feel warm.

Lie on your back, knees bent. Place both warm hands on your lower belly, below your belly button. Let the warmth sink in.

Inhale for 4 counts. Feel the warmth spread deeper as your belly rises. Your pelvic floor responds to warmth by softening.

Exhale for 6 counts. Imagine the warmth melting down from your hands, through your belly, to your pelvic floor.

When your hands cool, rub them together again and resume.

Picture it: your hands are two warm stones placed on your belly. The heat radiates downward through layers of muscle.`,
    inst_pt: `Esfregue as palmas das mãos vigorosamente por 10 segundos até ficarem quentes.

Deite de costas, joelhos dobrados. Coloque ambas as mãos quentes na barriga baixa, abaixo do umbigo. Deixe o calor penetrar.

Inspire por 4 tempos. Sinta o calor se espalhar mais fundo conforme a barriga sobe.

Expire por 6 tempos. Imagine o calor derretendo das suas mãos, através da barriga, até o assoalho pélvico.

Quando as mãos esfriarem, esfregue de novo e continue.

Visualize: suas mãos são duas pedras quentes colocadas na barriga. O calor irradia para baixo.`,
    breathe: 'Inhale to receive the warmth. Exhale to send it deeper.',
    breathe_pt: 'Inspire para receber o calor. Expire para enviar mais fundo.',
    timerCue: `Warmth.
Inhale.
Deeper.
Exhale.`,
    timerCue_pt: `Calor.
Inspire.
Mais fundo.
Expire.`,
    feel: 'Spreading warmth from hands through belly to pelvic floor.',
    feel_pt: 'Calor se espalhando das mãos pela barriga ao assoalho pélvico.',
    avoid: 'Do not press your hands into your belly. Do not bear down.',
    avoid_pt: 'Não pressione as mãos na barriga. Não faça força.',
    type: 'hold',
    sets: 12,
    hold: 4,
    relax: 6,
    rest: 0,
  },
};

export const days = [
  {
    day: 31, week: 5,
    title: 'Day 31', title_pt: 'Dia 31',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 32, week: 5,
    title: 'Day 32', title_pt: 'Dia 32',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 33, week: 5,
    title: 'Day 33', title_pt: 'Dia 33',
    exercises: [
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 34, week: 5,
    title: 'Day 34', title_pt: 'Dia 34',
    exercises: [
      { ref: 'push_and_return', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 35, week: 5,
    title: 'Day 35', title_pt: 'Dia 35',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 36, week: 6,
    title: 'Day 36', title_pt: 'Dia 36',
    exercises: [
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'side_lying_release', overrides: {"hold": 104} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 37, week: 6,
    title: 'Day 37', title_pt: 'Dia 37',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 38, week: 6,
    title: 'Day 38', title_pt: 'Dia 38',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'butterfly_breath', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'side_lying_release', overrides: {"hold": 100.0} }, // 100.0s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 39, week: 6,
    title: 'Day 39', title_pt: 'Dia 39',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'butterfly_breath', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 40, week: 6,
    title: 'Day 40', title_pt: 'Dia 40',
    exercises: [
      { ref: 'butterfly_breath', overrides: {} }, // 150s
      { ref: 'warm_hands_release', overrides: {"sets": 15} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 41, week: 6,
    title: 'Day 41', title_pt: 'Dia 41',
    exercises: [
      { ref: 'butterfly_breath', overrides: {} }, // 150s
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 42, week: 6,
    title: 'Day 42', title_pt: 'Dia 42',
    exercises: [
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 43, week: 7,
    title: 'Day 43', title_pt: 'Dia 43',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'pelvic_floor_drop', overrides: {"hold": 101} }, // 101s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 44, week: 7,
    title: 'Day 44', title_pt: 'Dia 44',
    exercises: [
      { ref: 'side_lying_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 45, week: 7,
    title: 'Day 45', title_pt: 'Dia 45',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 46, week: 7,
    title: 'Day 46', title_pt: 'Dia 46',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
    ], // Total: 299.0s = 5.0 min
  },
  {
    day: 47, week: 7,
    title: 'Day 47', title_pt: 'Dia 47',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'butterfly_breath', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 48, week: 7,
    title: 'Day 48', title_pt: 'Dia 48',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
      { ref: 'pelvic_floor_drop', overrides: {"hold": 146} }, // 146s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 49, week: 7,
    title: 'Day 49', title_pt: 'Dia 49',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 50, week: 8,
    title: 'Day 50', title_pt: 'Dia 50',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
    ], // Total: 299.0s = 5.0 min
  },
  {
    day: 51, week: 8,
    title: 'Day 51', title_pt: 'Dia 51',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'gentle_candle_blow', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 52, week: 8,
    title: 'Day 52', title_pt: 'Dia 52',
    exercises: [
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
    ], // Total: 295s = 4.9 min
  },
  {
    day: 53, week: 8,
    title: 'Day 53', title_pt: 'Dia 53',
    exercises: [
      { ref: 'butterfly_breath', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 54, week: 8,
    title: 'Day 54', title_pt: 'Dia 54',
    exercises: [
      { ref: 'push_and_return', overrides: {} }, // 150s
      { ref: 'butterfly_breath', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 55, week: 8,
    title: 'Day 55', title_pt: 'Dia 55',
    exercises: [
      { ref: 'side_lying_release', overrides: {} }, // 150s
      { ref: 'gentle_candle_blow', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 56, week: 8,
    title: 'Day 56', title_pt: 'Dia 56',
    exercises: [
      { ref: 'side_lying_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 57, week: 9,
    title: 'Day 57', title_pt: 'Dia 57',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 58, week: 9,
    title: 'Day 58', title_pt: 'Dia 58',
    exercises: [
      { ref: 'side_lying_release', overrides: {} }, // 150s
      { ref: 'pelvic_floor_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 59, week: 9,
    title: 'Day 59', title_pt: 'Dia 59',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'push_and_return', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 60, week: 9,
    title: 'Day 60', title_pt: 'Dia 60',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'butterfly_breath', overrides: {"hold": 101} }, // 101s
    ], // Total: 300s = 5.0 min
  },
];


export const monthMeta = {
  month: 2,
  program: 'release',
  phase: 'Release + Gentle Push',
  phase_pt: 'Soltura + Empurrar Suave',
  days_range: [31, 60],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}